module.exports = __webpack_public_path__ + "static/media/upload-file-icon.2d14cd29.svg";